module.exports = __webpack_public_path__ + "static/media/drag-equal.5b0b2d31.svg";